import QuestionsContainer from "./QuestionsContainer";

export default QuestionsContainer;
